import { render, staticRenderFns } from "./importEx.vue?vue&type=template&id=1ca17ab9&scoped=true"
import script from "./importEx.vue?vue&type=script&lang=js"
export * from "./importEx.vue?vue&type=script&lang=js"
import style0 from "./importEx.vue?vue&type=style&index=0&id=1ca17ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca17ab9",
  null
  
)

export default component.exports